import { createFileRoute, redirect } from '@tanstack/react-router'
import { CustomApplicationPage } from '@/pages/integrations/CustomApplicationPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/integrations_/custom/$applicationId_/datasets/$datasetId'
)({
  beforeLoad: ({ params }) => {
    if (params.datasetId === 'new') throw redirect({ to: '/workspaces/$workspaceId/integrations/custom/$applicationId', params: { workspaceId: params.workspaceId, applicationId: params.applicationId }, replace: true })
  },
  component: CustomDatasetRoute,
  staticData: { pageHeader: { title: 'Dataset', pad: false, scroll: false } },
})

function CustomDatasetRoute() {
  const { workspaceId, applicationId, datasetId } = Route.useParams()
  return <CustomApplicationPage workspaceId={workspaceId} applicationId={applicationId} datasetId={datasetId} />
}
